<template>
	<NewsTrending
		:title="meta.title"
		type="tag"
	/>
</template>

<script>
import {useApi} from '~/composables/api';
import {useNews} from "~/stores/news";
import {useStore} from '~/stores/store';
import {useRoute} from 'vue-router';
import metaJson from '@/include/meta-news.json';

export default {
    name: 'PageNews',
    async setup() {
		console.log('setup')
		definePageMeta({
			layout: 'news',
			middleware: ['entities-news', 'detect-url-news'],
		})

		const {$config} = useNuxtApp();
        const store = useStore();
        const news = useNews();
		const route = useRoute();
		let meta = metaJson[route.name] ?? metaJson['news-default'];
		console.log('%csetup() page-index', 'color: #99f', route.name, process.server ? 'server' : 'frontend')

		news.route = {
			name: route.name,
			query: {...route.query}
		};

		switch (route.name) {
			case 'news-market-crypto': {
				news.filters.marketType = 1;
				break;
			}

			case 'news-market-nft': {
				news.filters.marketType = 2;
				break;
			}

			case 'news-articles': {
				// news.setService('1');
				news.setFilters({services: [1]});
				break;
			}

            case 'news-tiktok': {
                news.setService('2');
                break;
            }

            case 'news-youtube': {
				news.setService('3');
				break;
			}

			case 'news-x-twitter': {
				news.setService('4');
				break;
			}

			case 'news-telegram': {
				news.setService('5');
				break;
			}

			case 'news-medium': {
				news.setService('6');
				break;
			}
		}
		// console.log('1', meta)

		useSeoMeta({
			title: `${meta.title} - DOXXY News`,
			ogTitle: `${meta.title} - DOXXY News`,
			description: meta.description,
			ogDescription: meta.description,
			ogImage: $config.public.OG_DEFAULT_IMAGE,
		});
		// console.log('2')

        return {
			meta,
			store,
            news
        };
    },
	data: () => ({
	}),
    watch: {
        'news.filters': {
            handler(val) {
                // console.log('%cwatch() index news.filters', 'color:red', this.$route.name)
				this.news.activeTab = 'news';
            },
            deep: true
        }
    },
};
</script>
